module.exports = __webpack_public_path__ + "media/typy/rolnicze@3x-7923bf59.svg";